export default __webpack_public_path__ + "static/media/femi-ogunji.80f82966.png";